'use client';
import * as React from 'react';
import { useTranslations } from 'next-intl';
import { Input } from '@/components/ui/field';
import { verifyPhoneAuthSession } from '@/lib/actions';
import { Button, FormError } from './ui';

export function PhoneMfaChallenge({
  challengeId,
  next = '/app',
}: {
  challengeId: string;
  next?: string;
}) {
  const t = useTranslations('auth');
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [pending, startTransition] = React.useTransition();
  const verify = (event: React.FormEvent) => {
    event.preventDefault();
    if (!challengeId || !/^\d{4}$/.test(code)) return;
    startTransition(async () => {
      setError(null);
      const result = await verifyPhoneAuthSession(challengeId, code);
      if (!result.ok) {
        setError(t('mfaInvalid'));
        return;
      }
      window.location.assign(next);
    });
  };

  return (
    <form onSubmit={verify} className="flex flex-col gap-3">
      <p className="text-sm text-muted-foreground">{t('mfaBody')}</p>
      <Input
        value={code}
        onChange={(event) => setCode(event.target.value.replace(/\D/g, '').slice(0, 4))}
        inputMode="numeric"
        autoComplete="one-time-code"
        icon="shield-key"
        placeholder={t('mfaCodePlaceholder')}
        aria-label={t('mfaCodePlaceholder')}
        required
      />
      <FormError>{error}</FormError>
      <Button
        type="submit"
        block
        size="lg"
        loading={pending}
        disabled={!challengeId}
      >
        {t('mfaConfirm')}
      </Button>
    </form>
  );
}
